/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPersonsPersonIdImpersonateV2Request
 */
export interface PostPersonsPersonIdImpersonateV2Request {
    /**
     * 
     * @type {string}
     * @memberof PostPersonsPersonIdImpersonateV2Request
     */
    target_url: string;
}

/**
 * Check if a given object implements the PostPersonsPersonIdImpersonateV2Request interface.
 */
export function instanceOfPostPersonsPersonIdImpersonateV2Request(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_url" in value;

    return isInstance;
}

export function PostPersonsPersonIdImpersonateV2RequestFromJSON(json: any): PostPersonsPersonIdImpersonateV2Request {
    return PostPersonsPersonIdImpersonateV2RequestFromJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonateV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsPersonIdImpersonateV2Request {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target_url': json['target_url'],
    };
}

export function PostPersonsPersonIdImpersonateV2RequestToJSON(value?: PostPersonsPersonIdImpersonateV2Request | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_url': value.target_url,
    };
}

